// assets/quiz-product-resolver.js
export function makeResolver({ fallback = {}, timeoutMs = 2000 } = {}) {
  return async function resolve(handle) {
    const ctrl = new AbortController();
    const t = setTimeout(() => ctrl.abort(), timeoutMs);
    const abortPromise = new Promise((_, reject) => {
      ctrl.signal.addEventListener('abort', () => reject(new Error('aborted')));
    });
    try {
      const res = await Promise.race([
        fetch(`/products/${handle}.js`, { signal: ctrl.signal }),
        abortPromise,
      ]);
      clearTimeout(t);
      if (!res.ok) throw new Error(`status ${res.status}`);
      const data = await res.json();
      return {
        handle: data.handle,
        price: data.price,
        compareAtPrice: data.compare_at_price,
        available: data.available,
        vendor: data.vendor,
        title: data.title,
        featuredImage: data.featured_image,
        url: data.url,
      };
    } catch {
      clearTimeout(t);
      return fallback[handle] || null;
    }
  };
}

if (typeof window !== 'undefined') window.makeResolver = makeResolver;
